import React, { useEffect, useRef, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import {
  Nav,
  Navbar,
  Accordion,
  Container,
  Dropdown,
} from "react-bootstrap";
import "./Header.scss";
import LogoImg from "../../assests/img/logo.png";
import BottomImg from "../../assests/img/menu-bg.png";
import CustomButton from "../CustomButton/CustomButton";
import Label from "../Label/Label";
import { useNavigate, useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import socialImg from "../../assests/img/social.svg";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import { useAuth } from "../../hooks/useAuth";

const SERVICE_MENU = [
  {
    title: "Mobile Apps",
    icon: "icon-mobile",
    path: "/ourservices",
    items: [
      { label: "Native iOS Apps", path: "/iosdevelopment", highlight: true },
      { label: "Native Android Apps", path: "/ourservices" },
      { label: "Cross Platform", path: "/ourservices" },
      { label: "Hybrid Apps", path: "/ourservices" },
      { label: "PWA", path: "/ourservices" },
    ],
  },
  {
    title: "Web Development",
    icon: "icon-desktop",
    path: "/ourservices",
    items: [
      { label: "Enterprise Solutions", path: "/ourservices" },
      { label: "ECommerce", path: "/ourservices" },
      { label: "CMS", path: "/ourservices" },
      { label: "API & Backend", path: "/ourservices" },
      { label: "Custom Development", path: "/ourservices" },
    ],
  },
  {
    title: "Design",
    icon: "icon-design",
    path: "/ourservices",
    items: [
      { label: "Discovery Workshop", path: "/ourservices" },
      { label: "Analysis", path: "/ourservices" },
      { label: "Wireframe", path: "/ourservices" },
      { label: "UI / UX Design", path: "/ourservices" },
    ],
  },
  {
    title: "Marketing",
    icon: "icon-marketing",
    path: "/packagesseo",
    items: [
      { label: "Content", path: "/packagesseo" },
      { label: "PPC Campaigns", path: "/packagesseo" },
      { label: "Social Media", path: "/packagesseo" },
    ],
  },
];

const CONTACT_SCROLL_PATHS = ["/", "/homepage", "/ourservices", "/aboutus", "/iosdevelopment"];

const Header = () => {
  const { t } = useTranslation();
  const { isLoggedIn, user, isAdmin, logout } = useAuth();
  const [show, setShow] = useState(false);
  const [serviceMenuOpen, setServiceMenuOpen] = useState(false);
  const closeServiceTimerRef = useRef(null);
  const serviceRootRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleLogout = () => {
    logout();
  };

  const handleClose = () => {
    setShow(false);
  };

  const closeServiceMenu = () => {
    setServiceMenuOpen(false);
  };

  const clearServiceCloseTimer = () => {
    if (closeServiceTimerRef.current) {
      clearTimeout(closeServiceTimerRef.current);
      closeServiceTimerRef.current = null;
    }
  };

  const openServiceMenu = () => {
    clearServiceCloseTimer();
    setServiceMenuOpen(true);
  };

  const scheduleCloseServiceMenu = () => {
    clearServiceCloseTimer();
    closeServiceTimerRef.current = setTimeout(() => {
      setServiceMenuOpen(false);
    }, 150);
  };

  const handleServiceMouseLeave = (event) => {
    const nextTarget = event.relatedTarget;

    if (nextTarget instanceof Node && serviceRootRef.current?.contains(nextTarget)) {
      return;
    }

    scheduleCloseServiceMenu();
  };

  const toggleServiceMenu = () => {
    clearServiceCloseTimer();
    setServiceMenuOpen((isOpen) => !isOpen);
  };

  useEffect(() => {
    return () => clearServiceCloseTimer();
  }, []);

  useEffect(() => {
    closeServiceMenu();
  }, [location.pathname]);

  const navigateTo = (path) => {
    closeServiceMenu();
    navigate(path);
  };

  const scrollToContact = () => {
    closeServiceMenu();

    if (CONTACT_SCROLL_PATHS.includes(location.pathname)) {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
      return;
    }

    navigate("/contactpage");
  };

  const clickToNavigate = (page) => {
    if (page === "bloglisting") {
      navigate("/bloglisting");
    } else if (page === "portfolio") {
      navigate("/portfolio");
    } else if (page === "contactUs") {
      scrollToContact();
    } else if (page === "iosDevelopment") {
      navigate("/iosdevelopment");
    } else if (page === "homepage") {
      navigate("/");
    } else if (page === "ourServices") {
      navigate("/ourservices");
    }
  };

  const handleServiceToggle = () => {
    if (window.innerWidth < 992) {
      toggleServiceMenu();
      return;
    }

    openServiceMenu();
  };

  const renderServiceItem = (item) => (
    <button
      type="button"
      key={item.label}
      className={`dropdown-item ${item.highlight ? "borderB colorRed" : ""}`}
      onClick={() => navigateTo(item.path)}
    >
      {item.label}
    </button>
  );

  const renderServiceMenuContent = () => (
    <div className="show-modal">
      <div className="dropdown-Options iPad">
        {SERVICE_MENU.map((section, index) => (
          <div
            className={`item-List ${index === SERVICE_MENU.length - 1 ? "paddR" : ""}`}
            key={section.title}
          >
            <button
              type="button"
              className={`dropdown-item mainTitle ${index === SERVICE_MENU.length - 1 ? "paddR" : ""}`}
              onClick={() => navigateTo(section.path)}
            >
              <i className={`${section.icon} colorRed`}></i>
              {section.title}
            </button>
            {section.items.map(renderServiceItem)}
          </div>
        ))}
      </div>
      <div className="mobile_Resp">
        <Accordion defaultActiveKey="0">
          {SERVICE_MENU.map((section, index) => (
            <Accordion.Item eventKey={String(index)} key={section.title}>
              <Accordion.Header>
                <i className={`${section.icon} colorRed`}></i>
                {section.title}
              </Accordion.Header>
              <Accordion.Body>
                <ul className="dropdown-Items">
                  {section.items.map((item) => (
                    <li key={item.label}>
                      <button
                        type="button"
                        className={`dropdown-item ${item.highlight ? "borderB colorRed" : ""}`}
                        onClick={() => navigateTo(item.path)}
                      >
                        {item.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
      <div className="btm_Img">
        <div className="image">
          <img src={BottomImg} alt="Discovery workshop call to action" />
          <div className="text-Btn">
            <div className="title-Btn">
              <Label title="Discovery Workshop"></Label>
              <Label title="Define functional scope of your project to plan project budget and timeline."></Label>
            </div>
            <CustomButton
              onClick={scrollToContact}
              type="button"
              title="Contact us"
            ></CustomButton>
          </div>
        </div>
      </div>
    </div>
  );

  const ModalPort = () => {
    return (
      <>
        <Modal show={show} onHide={handleClose} className="modal">
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="modalBody">
            <div className="portfolio_Page">
              <div className="content_Section">
                <Label title="Portfolio"></Label>
                <div></div>
                <Label
                  title="Sed ut perspiciatis unde omnis 
              iste natus error sit voluptatem accusantium doloremque
               laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo."
                ></Label>
              </div>

              <Carousel className="image_Section">
                <Carousel.Item>
                  <img
                    className="d-block w-100 img-fluid"
                    src={socialImg}
                    alt="First slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100 img-fluid"
                    src={socialImg}
                    alt="Second slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100 img-fluid"
                    src={socialImg}
                    alt="Third slide"
                  />
                </Carousel.Item>
              </Carousel>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  };

  return (
    <Navbar bg="light" expand="lg" className="ml-auto menuListing">
      <ModalPort />
      <Container className="container_Section">
        <Navbar.Brand>
          <div
            className="brand logo-Img"
            onClick={() => clickToNavigate("homepage")}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                clickToNavigate("homepage");
              }
            }}
            role="button"
            tabIndex={0}
          >
            <img src={LogoImg} alt="Digipank" />
          </div>
        </Navbar.Brand>
        <div className="main-Container">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav.Item
              as="div"
              ref={serviceRootRef}
              className={`service-nav-dropdown ${serviceMenuOpen ? "is-open" : ""}`}
              onMouseEnter={openServiceMenu}
              onMouseLeave={handleServiceMouseLeave}
            >
              <button
                type="button"
                className="nav-link service-nav-toggle"
                aria-expanded={serviceMenuOpen}
                onClick={handleServiceToggle}
              >
                {t("header.Service")}
              </button>
              <div
                className="dropdown-menu service-mega-menu"
                onMouseEnter={openServiceMenu}
                onMouseLeave={handleServiceMouseLeave}
              >
                {renderServiceMenuContent()}
              </div>
            </Nav.Item>
            <Nav className="me-auto">
              <Nav.Link onClick={() => clickToNavigate("portfolio")}>
                {t("header.Portfolio")}
              </Nav.Link>

              <Nav.Link onClick={() => clickToNavigate("bloglisting")}>
                {t("header.Blog")}
              </Nav.Link>
              {CONTACT_SCROLL_PATHS.includes(location.pathname) ? (
                <Nav.Link onClick={scrollToContact} role="button">
                  {t("header.Contact")}
                </Nav.Link>
              ) : (
                <Nav.Link onClick={() => clickToNavigate("contactUs")}>
                  {t("header.Contact")}
                </Nav.Link>
              )}

              <Nav.Link onClick={scrollToContact} className="colorRed">
                {t("header.Free website audit")}
              </Nav.Link>
              <Dropdown className="profile-dropdown">
                <Dropdown.Toggle variant="" id="dropdown-basic">
                  <span className="profile">
                    <i className="icon-profile profileCss"></i>
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={!isLoggedIn ? handleLoginClick : undefined}>
                    <span className="profile d-flex align-items-center">
                      <i className="icon-profile profileCss dropdown-profile"></i>
                      {isLoggedIn ? user?.name : "Login"}
                    </span>
                  </Dropdown.Item>
                  {isLoggedIn && (
                    <Dropdown.Item>
                      <span className="profile d-flex align-items-center">
                        <i className="icon-profile profileCss dropdown-profile"></i>
                        {user?.email}
                      </span>
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item>
                    <span className="profile d-flex align-items-center">
                      <span className="lang-icon">🌐</span>
                      <LanguageSwitcher></LanguageSwitcher>
                    </span>
                  </Dropdown.Item>
                  {isLoggedIn && (
                    <Dropdown.Item
                      onClick={handleLogout}
                      className={`profile-logout-item ${
                        isAdmin ? "logout-admin" : ""
                      }`}
                    >
                      <span
                        className={`profile d-flex align-items-center ${
                          isAdmin ? "logout-admin-text" : ""
                        }`}
                      >
                        <i className="icon-profile profileCss dropdown-profile"></i>
                        Logout
                      </span>
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;
